var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { g as getRootDomain, p as parseCookies, a as serialize_1, s as setCookieValue } from "../../../cookies-04bd2321.js";
import "../../../utils/logger.es.js";
class VisitIdServerAdapter {
  constructor(request, response) {
    __publicField(this, "request");
    __publicField(this, "response");
    this.request = request;
    this.response = response;
    if (!request && !response) {
      throw new Error("Resquest and Response object required");
    }
  }
  getCookieOptions() {
    var _a;
    const rootDomain = getRootDomain((_a = this.request.headers) == null ? void 0 : _a.host);
    return {
      domain: rootDomain,
      httpOnly: false,
      path: "/"
    };
  }
  parseCookies() {
    return parseCookies(this.request);
  }
  setCookie(cookieData, cookieOptions) {
    const existingCookies = this.response.getHeader("Set-Cookie") || [];
    const existingCookieArray = Array.isArray(existingCookies) ? existingCookies : [existingCookies];
    const cookieArray = Object.keys(cookieData).map(
      (cookie, index) => serialize_1(cookie, cookieData[cookie], cookieOptions[index])
    );
    const allCookies = [...existingCookieArray, ...cookieArray];
    this.response.setHeader("Set-Cookie", allCookies);
  }
}
class VisitIdNextServerAdapter {
  constructor(headers, cookies) {
    __publicField(this, "headers");
    __publicField(this, "cookies");
    this.headers = headers;
    this.cookies = cookies;
    if (!headers && !cookies) {
      throw new Error("Next Headers and Cookies object required");
    }
  }
  getCookieOptions() {
    const host = this.headers().get("host");
    const rootDomain = getRootDomain(host);
    return {
      domain: rootDomain,
      httpOnly: false,
      path: "/"
    };
  }
  parseCookies() {
    const cookieJar = this.cookies();
    return cookieJar.getAll().reduce((acc, cookie) => {
      acc[cookie.name] = cookie.value;
      return acc;
    }, {});
  }
  setCookie(cookieData, cookieOptions) {
    Object.entries(cookieData).forEach(([cookie, value], index) => {
      this.cookies().set(cookie, value, cookieOptions[index]);
    });
  }
}
class VisitIdBrowserAdapter {
  getCookieOptions() {
    const rootDomain = getRootDomain(window.location.hostname);
    return {
      domain: rootDomain,
      httpOnly: false,
      path: "/"
    };
  }
  parseCookies() {
    return parseCookies();
  }
  setCookie(cookieData, cookieOptions) {
    Object.keys(cookieData).forEach((cookie, index) => {
      setCookieValue(cookie, String(cookieData[cookie]), cookieOptions[index]);
    });
  }
}
export {
  VisitIdBrowserAdapter,
  VisitIdNextServerAdapter,
  VisitIdServerAdapter
};
